/**
 *  Point4
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @extends PIXI.Point
 * @memberOf race
 */
export default class Point4 extends PIXI.Point {
    /**
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
     * @param {number} [z=0] - position of the point on the z axis
     * @param {number} [w=0] - homogeneous w property
     */
    constructor(x = 0, y = 0, z = 0, w = 0) {
        super(x, y);

        /**
         * @member {number}
         * @default 0
         */
        this.z = z;

        /**
         * @member {number}
         * @default 0
         */
        this.w = w;
    }

    /**
     * @returns {Point4}
     */
    clone() {
        return new Point4(this.x, this.y, this.z, this.w);
    }

    /**
     * @param {Point4} p
     */
    copy(p) {
        this.set(p.x, p.y, p.z, p.w);
    }

    /**
     * @param {Point4} p
     * @returns {boolean}
     */
    equals(p) {
        return (p.x === this.x) && (p.y === this.y) && (p.z === this.z) && (p.w && this.w);
    }

    /**
     * @param {!number} [x=0]
     * @param {!number} [y=0]
     * @param {!number} [z=0]
     * @param {!number} [w=0]
     */
    set(x, y, z, w) {
        this.x = x || 0;
        this.y = y || ((y !== 0) ? this.x : 0);
        this.z = z || ((z !== 0) ? this.x : 0);
        this.w = w || ((w !== 0) ? this.x : 0);
    }
}